import { render, staticRenderFns } from "./PageThirteenth.vue?vue&type=template&id=1c485063&scoped=true"
import script from "./PageThirteenth.vue?vue&type=script&lang=js"
export * from "./PageThirteenth.vue?vue&type=script&lang=js"
import style0 from "./PageThirteenth.vue?vue&type=style&index=0&id=1c485063&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c485063",
  null
  
)

export default component.exports